import { render } from "./locked-users-grid.vue?vue&type=template&id=1ec1a1d0"
import script from "./locked-users-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./locked-users-grid.vue?vue&type=script&setup=true&lang=js"

import "./locked-users-grid.vue?vue&type=style&index=0&id=1ec1a1d0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/locks/locked-users-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ec1a1d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ec1a1d0', __exports__)) {
    api.reload('1ec1a1d0', __exports__)
  }
  
  module.hot.accept("./locked-users-grid.vue?vue&type=template&id=1ec1a1d0", () => {
    api.rerender('1ec1a1d0', render)
  })

}


export default __exports__